/* eslint-disable import/no-unresolved */
import ReportConfigDetails from 'views/Rules/common/ReportConfigDetails';

const FRY7QReportConfigDetails = ({
    selectedFRY7QQuarter, setSelectedFRY7QQuarter, summaryQuartersFRY7QData, commonFRY7QData,
}) => (
    <ReportConfigDetails
        selectedQuarter={selectedFRY7QQuarter}
        setSelectedQuarter={setSelectedFRY7QQuarter}
        summaryQuartersData={summaryQuartersFRY7QData}
        commonData={commonFRY7QData}
        displayColumn="Yes"
        istopier="Yes"
        rule="FRY7Q"
    />
);

export default FRY7QReportConfigDetails;
